module.exports = __webpack_public_path__ + "img/x8.68d57480.jpg";